/**
 * A class for holding references to all "skeleton" DOM elements,
 * neccessary for the mounting of other UI and DOM.
 */

class Refs {
    public wrapper: HTMLDivElement = null;
    public root: HTMLDivElement = null;
    public solution: HTMLDivElement = null;
    public ui: HTMLDivElement = null;
}

export default Refs;